<template>
    <div class="agreement">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>大客户管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm"  size="mini">
                    <el-form-item label="公司名称">
                        <el-input v-model="searchForm.companyName" placeholder="公司名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="物料号">
                        <el-input v-model="searchForm.materialNumber" placeholder="物料号" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品编码">
                        <el-input v-model="searchForm.sku" placeholder="商品编码" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品名称">
                        <el-input v-model="searchForm.productName" placeholder="商品名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                        <el-button type="primary" @click="handleExport" size="mini">条件导出</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                 <el-table  size="mini" stripe
                    :height="tableConfig.height"
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column
                        prop="companyName"
                        label="公司名称">
                    </el-table-column>
                    <el-table-column
                        prop="productName"
                        label="商品名称">
                    </el-table-column>
                    <el-table-column
                        prop="sku"
                        label="商品编号">
                    </el-table-column>
                    <el-table-column
                        prop="materialNumber"
                        label="物料号">
                    </el-table-column>
                    <el-table-column label="操作" width="350" align="right">
                        <template slot="header">
                            <a href="/template/customer_product.xlsx" style="margin-right:16px">下载模板</a>
                            <el-button type="primary" @click="() => uploadDialogVisible = true" size="mini">批量上传</el-button>
                            <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text"
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button type="text"
                                size="mini"

                                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="物料号维护" :visible.sync="editDialogVisible" width="330px" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
                <el-form-item label="公司名称" prop="companyId">
                    <el-select v-model="editForm.companyId" filterable placeholder="请选择公司名称">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品编号" prop="sku">
                    <el-input v-model="editForm.sku" placeholder="请输入商品编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="物料号" prop="materialNumber">
                    <el-input v-model="editForm.materialNumber" placeholder="请输入物料号" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="导入物料号" :modal="true" :visible.sync="uploadDialogVisible" width="400px">
            <el-upload ref="upload"
                class="upload-demo"
                drag
                action="/api/admin/customerProduct/upload"
                :limit="1"
                accept=".xlsx"
                :on-success="uploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-html="uploadCheckResult"></div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {

    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {
                sku: "",
                companyName: "",
                materialNumber: "",
                productName: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            uploadDialogVisible: false,
            uploadCheckResult: "",
            fileList: [],
            editForm: {
                id: "",
                companyId: "",
                sku: "",
                materialNumber: "",
                status: null,
            },
            options: [],
            rules: {
                companyId: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                sku: [
                    { required: true, message: '请输入商品编号', trigger: 'blur' }
                ],
                materialNumber: [
                    { required: true, message: '请输入物料号', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onSearch() {
            let company = {
            };
            if(this.searchForm.name != "") {
                company["name"] = this.searchForm.name;
            }
            if(this.searchForm.domain != "") {
                company["domain"] = this.searchForm.domain;
            }
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/customerProduct/search",{
                cond: this.searchForm,
                page: this.currentPage - 1,size:this.pageSize,
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        handleCreate() {
            this.editForm = {
                id: "",
                companyId: "",
                sku: "",
                materialNumber: "",
                status: 1,
            };
            this.editDialogVisible = true;
        },
        onSubmit() {
            let _this = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/customerProduct/save", this.editForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.editDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.companyId = row.companyId;
            this.editForm.sku = row.sku;
            this.editForm.materialNumber = row.materialNumber;
            this.editForm.status = row.status;
            this.editDialogVisible = true;
        },
        handleUpload(index, row) {
            this.editForm.id = row.id;
            this.uploadDialogVisible = true;
        },
        handleDelete(index, row) {
            let _this = this;
            this.$confirm('是否删除【' + row.companyName + '】公司的物料号【' + row.materialNumber + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/customerProduct/delete/" + row.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            }).catch(function() {
                _this.$notify.error({
                    title: '错误',
                    message: "保存失败"
                });
            });
        },
        uploadSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.upload.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '数据保存成功',
                    type: 'success'
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadCheckResult = msg;
            }
        },
        handleExport() {
            let url = "/api/admin/customerProduct/export";
            let param = [];
            this.searchForm.companyName && param.push("companyName=" + this.searchForm.companyName);
            this.searchForm.sku && param.push("sku=" + this.searchForm.sku);
            this.searchForm.materialNumber && param.push("materialNumber=" + this.searchForm.materialNumber);
            this.searchForm.productName && param.push("productName=" + this.searchForm.productName);
            param.length > 0 && (url = url + "?" + param.join("&"));
            window.open(url, "_blank");
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
    },
    created() {
        const that = this;
        this.$axios.post("/admin/company/list", {})
        .then(function(response) {
            const resp = response.data;
            if(resp.header.status == 0) {
                that.options = resp.data;
                that.onSearch();
            }
        }).catch(function() {
        });
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }

    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
</style>
